import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './reducer'
import * as state from './state'

export const vendorState = createFeatureSelector<state.State>('vendors')

export const isVendorsLoaded = createSelector(vendorState, (s: state.State) => s.isLoaded)

export const selectAllVendors = createSelector(vendorState, reducer.selectAll)

export const selectVendorById = (id: string) =>
  createSelector(reducer.selectEntities, (entities) => {
    return entities[id]
  })

export const selectVendorByIds = (ids: string[]) =>
  createSelector(selectAllVendors, (items) => {
    return items.filter((i) => ids.includes(i.pkey))
  })
